import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { NewAuthService } from 'src/app/services/auth/new-auth-service.service';
import { SearchChatsParamsRes } from '../inbox-sms.model';
import { InboxSmsService } from '../inbox-sms.service';

@Injectable({
  providedIn: 'root',
})
export class InboxListResolver implements Resolve<SearchChatsParamsRes> {
  user = this.auth.user;
  searchParams = { userId: this.user.user_id };
  pageSize = 10;
  constructor(private inboxService: InboxSmsService, private auth: NewAuthService) {}

  resolve(): Observable<SearchChatsParamsRes> {
    return this.inboxService.getChats(this.searchParams, this.pageSize, {
      page: 1,
      sort: { field: 'lastMessageAt', order: 'desc' },
    });
  }
}
